export const blockIconsAndroidPinNew = (
	<span className='material-symbols-outlined'>pin</span>
);
